import { render, staticRenderFns } from "./handhome4.vue?vue&type=template&id=636bf24a&scoped=true"
import script from "./handhome4.vue?vue&type=script&lang=js"
export * from "./handhome4.vue?vue&type=script&lang=js"
import style0 from "./handhome4.vue?vue&type=style&index=0&id=636bf24a&prod&lang=scss"
import style1 from "./handhome4.vue?vue&type=style&index=1&id=636bf24a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636bf24a",
  null
  
)

export default component.exports